import React from 'react'
import PropTypes from 'prop-types'
import Avatar from 'components/Utils/Avatar'

export const UserPreview = ({ userLabel, userPhotoURL }) => (
  <div className="flexbox flexbox-align-center">
    <Avatar url={userPhotoURL} name={userLabel} size="small" />
    <div className="margin-left-small">{userLabel}</div>
  </div>
)

UserPreview.propTypes = {
  userLabel: PropTypes.string.isRequired,
  userPhotoURL: PropTypes.string,
}

export default UserPreview
